function adjustMicrocopy() {
  document.querySelectorAll('.lp202607__microcopy').forEach(el => {

    let fontSize = window.innerWidth <= 767 ? 28 : 40;
    el.style.fontSize = fontSize + 'px';

    while (el.scrollWidth > el.clientWidth && fontSize > 12) {
      fontSize--;
      el.style.fontSize = fontSize + 'px';
    }

  });
}

document.addEventListener('DOMContentLoaded', adjustMicrocopy);
window.addEventListener('resize', adjustMicrocopy);